const DocumentsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#ff9100"
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#fff"
      fillOpacity={0.9}
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#ff9100"
      d="m33.58 32.82 1.84 1.693-7.828 8.503-4.015-4.394 1.846-1.687 2.175 2.382 5.982-6.497Z"
    />
    <path
      fill="#000"
      fillOpacity={0.4}
      d="m33.58 32.82 1.84 1.693-7.828 8.503-4.015-4.394 1.846-1.687 2.175 2.382 5.982-6.497Z"
    />
    <path
      fill="#ff9100"
      fillRule="evenodd"
      d="M45.333 44.5v-30H23.667v5h-5v30h21.666v-5h5Zm-5-2.5V27.02l-7.47-7.52h-6.696V17h16.666v25h-2.5ZM29.318 22h-8.151v25h16.666V30.542h-8.515V22Zm2.5 0v6.042h6.006L31.823 22h-.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillOpacity={0.4}
      fillRule="evenodd"
      d="M45.333 44.5v-30H23.667v5h-5v30h21.666v-5h5Zm-5-2.5V27.02l-7.47-7.52h-6.696V17h16.666v25h-2.5ZM29.318 22h-8.151v25h16.666V30.542h-8.515V22Zm2.5 0v6.042h6.006L31.823 22h-.005Z"
      clipRule="evenodd"
    />
  </svg>
);
export default DocumentsIcon;
